const parseHexToRgb = (hex: null | string | undefined) => {
  if (!hex || typeof hex !== "string") return null;
  const cleaned = hex.replace("#", "");
  if (cleaned.length === 3) {
    const r = parseInt(cleaned[0] + cleaned[0], 16);
    const g = parseInt(cleaned[1] + cleaned[1], 16);
    const b = parseInt(cleaned[2] + cleaned[2], 16);
    return { b, g, r };
  }
  if (cleaned.length === 6) {
    const r = parseInt(cleaned.slice(0, 2), 16);
    const g = parseInt(cleaned.slice(2, 4), 16);
    const b = parseInt(cleaned.slice(4, 6), 16);
    return { b, g, r };
  }
  return null;
};

export const toRgb = (hex: null | string | undefined): string => {
  const rgb = parseHexToRgb(hex);
  if (!rgb) return "";
  return `${rgb.r}, ${rgb.g}, ${rgb.b}`;
};

const COLOR_FOR_RENDERING_INPUT_ON_CHANGE = "#000000";
export const getValueColorForRenderingInputOnChange = (color: string | undefined) => {
  const isColorChangeBeingIgnored = color === undefined || color === null;
  if (isColorChangeBeingIgnored) return COLOR_FOR_RENDERING_INPUT_ON_CHANGE;
  return color;
};
